/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../data.ts"/>


module DealerwareWebData {

    "use strict";

    getDealerwareWebDataModule()
        .constant(
            'braintreeTransactionCodes', {
                1000: 'Approved',
                1001: 'Approved, check customer ID',
                1002: 'Processed',
                2000: 'Do Not Honor',
                2001: 'Insufficient Funds',
                2002: 'Limit Exceeded',
                2003: 'Cardholder\'s Activity Limit Exceeded',
                2004: 'Expired Card',
                2005: 'Invalid Credit Card Number',
                2006: 'Invalid Expiration Date',
                2007: 'No Account',
                2008: 'Card Account Length Error',
                2009: 'No Such Issuer',
                2010: 'Card Issuer Declined CVV',
                2011: 'Voice Authorization Required',
                2012: 'Processor Declined – Possible Lost Card',
                2013: 'Processor Declined – Possible Stolen Card',
                2014: 'Processor Declined – Fraud Suspected',
                2015: 'Transaction Not Allowed',
                2016: 'Duplicate Transaction',
                2017: 'Cardholder Stopped Billing',
                2018: 'Cardholder Stopped All Billing',
                2019: 'Invalid Transaction',
                2020: 'Violation',
                2021: 'Security Violation',
                2022: 'Declined – Updated Cardholder Available',
                2023: 'Processor Does Not Support This Feature',
                2024: 'Card Type Not Enabled',
                2025: 'Set Up Error – Merchant',
                2026: 'Invalid Merchant ID',
                2027: 'Set Up Error – Amount',
                2028: 'Set Up Error – Hierarchy',
                2029: 'Set Up Error – Card',
                2030: 'Set Up Error – Terminal',
                2031: 'Encryption Error',
                2032: 'Surcharge Not Permitted',
                2033: 'Inconsistent Data',
                2034: 'No Action Taken',
                2035: 'Partial Approval For Amount In Group III Version',
                2036: 'Authorization could not be found to reverse',
                2037: 'Already Reversed',
                2038: 'Processor Declined',
                2039: 'Invalid Authorization Code',
                2040: 'Invalid Store',
                2041: 'Declined – Call For Approval',
                2042: 'Invalid Client ID',
                2043: 'Error – Do Not Retry, Call Issuer',
                2044: 'Declined – Call Issuer',
                2045: 'Invalid Merchant Number',
                2046: 'Declined',
                2047: 'Call Issuer. Pick Up Card',
                2048: 'Invalid Amount',
                2049: 'Invalid SKU Number',
                2050: 'Invalid Credit Plan',
                2051: 'Credit Card Number does not match method of payment',
                2053: 'Card reported as lost or stolen',
                2054: 'Reversal amount does not match authorization amount',
                2055: 'Invalid Transaction Division Number',
                2056: 'Transaction amount exceeds the transaction division limit',
                2057: 'Issuer or Cardholder has put a restriction on the card',
                2058: 'Merchant not Mastercard SecureCode enabled',
                2059: 'Address Verification Failed',
                2060: 'Address Verification and Card Security Code Failed',
                2061: 'Invalid Transaction Data',
                2062: 'Invalid Tax Amount',
                2063: 'PayPal Business Account preference resulted in the transaction failing',
                2064: 'Invalid Currency Code',
                2065: 'Refund Time Limit Exceeded',
                2066: 'PayPal Business Account Restricted',
                2067: 'Authorization Expired',
                2068: 'PayPal Business Account Locked or Closed',
                2069: 'PayPal Blocking Duplicate Order IDs',
                2070: 'PayPal Buyer Revoked Future Payment Authorization',
                2071: 'PayPal Payee Account Invalid Or Does Not Have a Confirmed Email',
                2072: 'PayPal Payee Email Incorrectly Formatted',
                2073: 'PayPal Validation Error',
                2074: 'Funding Instrument In The PayPal Account Was Declined By The Processor Or Bank, Or It Can\'t Be Used For This Payment',
                2075: 'Payer Account Is Locked Or Closed',
                2076: 'Payer Cannot Pay For This Transaction With PayPal',
                2077: 'Transaction Refused Due To PayPal Risk Model',
                2079: 'PayPal Merchant Account Configuration Error',
                2081: 'PayPal pending payments are not supported',
                2082: 'PayPal Domestic Transaction Required',
                2083: 'PayPal Phone Number Required',
                2084: 'PayPal Tax Info Required',
                2085: 'PayPal Payee Blocked Transaction',
                2086: 'PayPal Transaction Limit Exceeded',
                2087: 'PayPal reference transactions not enabled for your account',
                2088: 'Currency not enabled for your PayPal seller account',
                2089: 'PayPal payee email permission denied for this request',
                2090: 'PayPal account not configured to refund more than settled amount',
                2091: 'Currency of this transaction must match currency of your PayPal account',
                2092: 'Processor Declined',
                2999: 'Processor Declined',
                3000: 'Processor Network Unavailable'
            }
        )
        .constant(
            'braintreeTransactionStatuses', {
                authorized                  : 'Authorized',
                authorization_expired       : 'Authorization Expired',
                submitted_for_settlement    : 'Submitted For Settlement',
                settling                    : 'Settling',
                settlement_pending          : 'Settlement Pending',
                settlement_declined         : 'Settlement Declined',
                settled                     : 'Settled',
                voided                      : 'Voided',
                declined                    : 'Processor Declined',
                gateway_rejected            : 'Gateway Rejected',
                failed                      : 'Failed'
            }
        )
        .constant(
            'braintreeTransactionTypes', {
                sale    : 'Sale',
                credit  : 'Credit'
            }
        );
}
